module.exports = __webpack_public_path__ + "img/selected-house.dc832df9.png";